<!-- @veltra/icons generated sha256:4aac8cf70d34c322 gen:8 source:src/svg/normal/loading.svg -->
<script setup lang="ts">
defineOptions({ name: 'Loading' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M8 1.5a6.5 6.5 0 0 0 0 13v-1.625A4.875 4.875 0 1 1 12.875 8H14.5A6.5 6.5 0 0 0 8 1.5"
    />
  </svg>
</template>
